import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=Minimal%20clean%20desk%20scene%20with%20a%20laptop%20and%20tablet%20showing%20a%20tidy%20product%20spreadsheet%20grid%20of%20fashion%20items%2C%20soft%20warm%20neutral%20tones%2C%20sage%20green%20accents%2C%20bright%20airy%20natural%20light%2C%20modern%20editorial%20style%2C%20fresh%20organized%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1200&height=800&seq=usfans-about-01&orientation=landscape"
            alt="USFans Spreadsheet organized product list"
            className="w-full h-auto rounded-lg object-cover object-top"
          />
        </div>

        <div>
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
            {t("hero.badge")}
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-heading font-bold">
            {t("about.title")}
          </h2>
          <p className="mt-4 text-foreground-700 leading-relaxed">{t("about.p1")}</p>
          <p className="mt-4 text-foreground-700 leading-relaxed">{t("about.p2")}</p>
        </div>
      </div>
    </section>
  );
}